import React, { useEffect } from "react";
import PasswordChange from "./PasswordChange";
import DeleteAccount from "./DeleteAccount";
import EmailChange from "./EmailChange";
import SocialMedia from "./SocialMedia";
import LinkedAccounts from "./LinkedAccounts";
import EmailSubscriptions from "../Notifications/EmailSubscriptions";

const MyAccount = (props) => {
  const { setPage } = props;

  useEffect(() => {
    setPage("My Account");
  }, []);

  return (
    <div className="settings-route-page settings_my-account">
      <EmailChange {...props} email={props.userSettings && props.userSettings.email} />
      <LinkedAccounts setRedirectingProvider={props.setRedirectingProvider} />
      <SocialMedia {...props} />
      <PasswordChange {...props} />
      <EmailSubscriptions {...props} />
      <DeleteAccount {...props} />
    </div>
  );
};

export default MyAccount;
